module.exports = __webpack_public_path__ + "static/media/uploadPic.3742966e.svg";